import { type ActionItem } from 'shared/ui'
import { type SurveyRow } from 'entities/Surveys/model/SurveyRow'
import { deleteSurvey } from 'pages/surveys/ui/actions/deleteSurvey/deleteSurvey'
import { editSurvey } from './editSurvey/editSurvey'
import { detailsSurvey } from './detailsSurvey/detailsSurvey'

export const getSurveyRowActions = (
  item: SurveyRow,
  onDeleteItem: (id: number) => void
): ActionItem[] => {
  return [
    editSurvey(item.id),
    detailsSurvey(item),
    { text: 'Duplicate', icon: 'copy' },
    {
      text: 'Delete',
      icon: 'delete',
      group: 'Actions',
      onAction: () => deleteSurvey(item, onDeleteItem),
    },
  ]
}
